module.exports = __webpack_public_path__ + "img/success-change-password.8658fb12.png";